import {Pipe, PipeTransform} from '@angular/core';
import * as Nzh from 'nzh';

const nzh = new Nzh({
    ch: "é¶å£¹è´°åèä¼éææç",      // æ°å­å­ç¬¦
    ch_u: "ä¸ªæ¾ä½°ä»ä¸äº¿åäº¬",       // æ°ä½åä½å­ç¬¦ï¼ä¸ä»¥ä¸åè¿å¶ï¼ä¸ä»¥ä¸ä¸è¿å¶ï¼ä¸ªä½ä¸è½çç¥
    ch_f: "è´",                   // è´å­ç¬¦
    ch_d: "ç¹",                   // å°æ°ç¹å­ç¬¦
    m_u: 'åè§åå',              // éé¢åä½
    m_t: "äººæ°å¸",                // éé¢åç¼
    m_z: "æ´"                    // éé¢æ å°æ°åç¼
});

@Pipe({
    name: 'convertCurrency'
})
export class ConvertCurrencyPipe implements PipeTransform {

    /**
     * éé¢è½¬ä¸­æ
     * @param value æ°å­éé¢
     * @param symbol æ¯å¦å¸¦éé¢åç¼(äººæ°å¸)
     */
    transform(value: any, symbol = false): any {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        return nzh.toMoney(value, {outSymbol: symbol});
    }
}
